import ArrowDownSvg from '../../images/icons/arrow.svg';
import { DetailedHTMLProps, HTMLAttributes, ReactNode, useState } from 'react';

const ArrowButton = (props: ExtendedArrowButtonProps) => {
  const { children,
    isGhost = true,
    className = '',
    imgClass = ''
  } = props;

  // remove isGhost from props
  const computedProps = { ...props };
  delete computedProps.isGhost;

  const [isHovered, setIsHovered] = useState(isGhost);

  return (
    <div
      onMouseEnter={() => setIsHovered(!isHovered)}
      onMouseLeave={() => setIsHovered(!isHovered)}
      className={`${className} ${children ? 'flex items-center' : 'inline-block'}`}
      role="button"
      tabIndex={0}
      {...computedProps}
    >
      <img src="/arrow-right.svg" alt="arrow" className={`${imgClass} ${isHovered ? 'inline-block' : 'hidden'} cursor-pointer`} loading="lazy" />
      <img src="/arrow-right-inverted.svg" alt="arrow" className={`${imgClass} ${!isHovered ? 'inline-block' : 'hidden'} cursor-pointer`} loading="lazy" />
      {children}
    </div>
  )
}

export const ArrowDown = ({ className = '', onClick, ...props }: { className?: string, onClick?: () => void }) => <ArrowDownSvg onClick={onClick} className={`arrow-down ${className}`} {...props} />

export default ArrowButton;

type ArrowButtonProps = {
  children?: ReactNode
  isGhost?: boolean
  className?: string
  imgClass?: string
}

type ExtendedArrowButtonProps = ArrowButtonProps & Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, keyof ArrowButtonProps>;
